/**
 * Whether this browser has the Popover API. It arrived in Chrome 114 and
 * Safari 17, and the browserslist reaches back to Chrome 111 and Safari 16.4,
 * so anything built on it needs a way to work without it.
 */
export const supportsPopover = (): boolean =>
  typeof HTMLElement !== 'undefined' && Object.hasOwn(HTMLElement.prototype, 'popover');

/**
 * Hides a popover if it is showing. The first browsers with the API threw on
 * hiding one that was already hidden (the spec later made it a no-op), so the
 * error is swallowed rather than every caller checking `:popover-open` first.
 */
export const hidePopover = (element: HTMLElement): void => {
  try {
    element.hidePopover();
  } catch {
    // Already hidden.
  }
};

/** Hides every popover under `root`: none where the browser has no Popover API. */
export const hidePopoversIn = (root: ParentNode): void => {
  if (!supportsPopover()) { return; }
  root.querySelectorAll<HTMLElement>('[popover]').forEach(hidePopover);
};
